module.exports = __webpack_public_path__ + "static/img/solution-whalefriendly.752c2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solutions/solution-whalefriendly.png
// module id = oX/m
// module chunks = 0